import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import registerServiceWorker from './registerServiceWorker';
import { BrowserRouter } from 'react-router-dom';
import state from './store';
import { Provider } from 'mobx-react';

ReactDOM.render(
  <BrowserRouter>
    <Provider state={state}><App/></Provider>
  </BrowserRouter>,
  document.getElementById('root'));
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js